import { map, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { AppService } from 'src/app/core/services/app.service'
import { gridData } from '../model/dataModels/gridData';

@Injectable({
  providedIn: 'root'
})
export class HttpDataService 
{
  constructor(private httpClient: HttpClient, private appService: AppService ) { }

  private getPostHeaders(): any 
  {
    if(this.appService.tokenOAuth != undefined)
    {
      return { 'Authorization': this.appService.tokenOAuth };
    }
  }

  public GetList<T>(endpoint: string) : Observable<T[]>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.get<T[]>(endpoint, {headers}).pipe(map(result => { return result; }));
  }

  public Get<T>(endpoint: string) : Observable<T>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.get<T>(endpoint, {headers}).pipe(map(result => { return result; }));
  }

  public Post<T>(endpoint: string, body: any) : Observable<T>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.post<T>(endpoint, body, {headers}).pipe(map(result => { return result; }));
  }

  public Put<T>(endpoint: string, body: any) : Observable<T>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.put<T>(endpoint, body, {headers}).pipe(map(result => { return result; }));
  }

  public Delete(endpoint: string) : Observable<number>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.delete<number>(endpoint, {headers}).pipe(map(result => { return result; }));
  }

  public getGridData(endpoint: string, params: { [key: string]: any }): Observable<gridData> 
  {
    const headers = this.getPostHeaders();
    return this.httpClient.get<gridData>(endpoint, { headers, params });
  }

  public GetBinary(endpoint: string) : Observable<Blob>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.get(endpoint, {headers, responseType: 'blob' });
  }

  public GetBinaryWithParams(endpoint: string, params: { [key: string]: any }): Observable<Blob>
  {
    const headers = this.getPostHeaders();
    return this.httpClient.get(endpoint, {headers, params, responseType: 'blob'});
  }
}